import { useTranslation } from 'react-i18next'

import { InputWithLabel, TextArea } from '@reveni-io/reveni-ui'

import DatePicker from '@/common/components/DatePicker/DatePicker'

import { errorTypes } from '../constants'
import * as Styles from './styles'

const PolicyRuleBasicInfo = ({ name, notes, validFrom, validUntil, onChange, errors = [], disabled }) => {
  const { t } = useTranslation()

  const handleChange = (field, value) => {
    onChange({ [field]: value })
  }

  const shouldShowError = errorType => {
    return errors.find(error => error.type === errorType)
  }

  return (
    <Styles.Container id={errorTypes.nameEmpty}>
      <InputWithLabel
        label={t('Nombre de la regla')}
        value={name}
        onChange={e => handleChange('name', e.target.value)}
        fullWidth
        error={shouldShowError(errorTypes.nameEmpty)}
        helperText={shouldShowError(errorTypes.nameEmpty) && t('Este campo es obligatorio')}
        disabled={disabled}
      />
      <TextArea
        label={t('Descripción')}
        value={notes}
        onChange={e => handleChange('notes', e.target.value)}
        showCounter
        maxLength={500}
        disabled={disabled}
      />
      <Styles.DateRow>
        <DatePicker
          value={validFrom}
          onChange={value => handleChange('valid_from', value)}
          label={t('Válida desde')}
          disabled={disabled}
          fullWidth
          clearable
        />
        <DatePicker
          value={validUntil}
          onChange={value => handleChange('valid_until', value)}
          label={t('Válida hasta')}
          disabled={disabled}
          fullWidth
          clearable
        />
      </Styles.DateRow>
    </Styles.Container>
  )
}

export default PolicyRuleBasicInfo
